exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Icon{display:flex;align-items:center;justify-content:center;flex-grow:0;flex-shrink:0;color:attr(data-color)}\n", ""]);

// exports
